import { AvatarBase } from "@/components/Avatar/base";
import Icon from "@/components/Icon/Icon";
import { cn } from "@/lib/cn";
import { genNameInitials } from "@/utils/name";
import type { ComponentProps } from "react";
import { P, match } from "ts-pattern";

type Base = Omit<
  ComponentProps<typeof AvatarBase>,
  "alt" | "fallback" | "shape" | "variant"
>;
type Props = {
  name?: string;
} & Base;

// サイズに基づくイニシャルフォントサイズ設定
const fontSize = {
  12: "text-[8px]",
  16: "text-[10px]",
  24: "text-xs",
  32: "text-sm",
} satisfies Record<NonNullable<Props["size"]>, string>;

/**
 * 人物のアバターを表示するコンポーネントです。
 * nameを指定してsrcが見つからない場合、イニシャル（一文字）がフォールバックとして表示されます。
 */
export function AvatarPerson(props: Props) {
  const { name, size = 24 } = props;

  const fallback = match(name)
    .with(P.nullish, () => <Icon iconName="UserIcon" />)
    .otherwise((n) => (
      <span className={cn("text-neutral-on-fill", fontSize[size])}>
        {genNameInitials(n, 1)}
      </span>
    ));

  return (
    <AvatarBase {...props} size={size} alt={name ?? ""} fallback={fallback} />
  );
}
